import { getCsrfValue } from "../../api/ApiHelper";

import { CAPTCHA_SITE_KEY_FIELD } from "../../utils/constants";
import { resolveApiUrl } from "../../utils/url/urlResolver";

interface ApiFields {
  email: string;
  captcha: string;
  generalTerms: boolean;
  privacyPolicy: boolean;
  marketingConsent?: boolean;
}

const apiUrl = resolveApiUrl("/registered/user/registration");

export const registerUser = (data: ApiFields): Promise<any> => {
  const params = new URLSearchParams();
  params.set("email", data.email);
  params.set(CAPTCHA_SITE_KEY_FIELD, data.captcha);
  params.set("generalTerms", data.generalTerms.toString());
  params.set("privacyPolicy", data.privacyPolicy.toString());
  params.set("marketingConsent", data.marketingConsent?.toString() ?? "false");
  return fetch(apiUrl, {
    body: params.toString(),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json();
    }
  });
};
